import { useState } from 'react'
import type { ProviderManagement } from '../types'
import { useClearStaleSelection } from './useClearStaleSelection'

interface TransferFormState {
  from: ProviderManagement | null
  to: ProviderManagement | null
}

const initial: TransferFormState = {
  from: null,
  to: null,
}

export const useTransferForm = (
  fromOptions: ProviderManagement[],
  toOptions: ProviderManagement[],
) => {
  const [form, setForm] = useState<TransferFormState>(initial)

  const update = (patch: Partial<TransferFormState>) =>
    setForm((prev) => ({ ...prev, ...patch }))

  const reset = () => setForm(initial)

  useClearStaleSelection(form.from, fromOptions, () => update({ from: null }))
  useClearStaleSelection(form.to, toOptions, () => update({ to: null }))

  return { form, update, reset }
}
